import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["windowsContainer", "window", "addButtonContainer", "destroyField"];

  connect() {
    this.hideMarkedForDestructionWindows();
    this.updateAddButtonVisibility();
  }

  addWindow(event) {
    event.preventDefault();

    const template = document.getElementById("transfer-window-template").content.cloneNode(true);

    const newIndex = this.windowsContainerTarget.children.length;
    const newFields = template.querySelectorAll("[name]");

    newFields.forEach((field) => {
      field.name = field.name.replace("[]", `[${newIndex}]`);
    });

    // Set the day to the first available day
    const daySelect = template.querySelector("select[name*='[day_of_week]']");
    if (daySelect) {
      const availableDay = this.getFirstAvailableDay();
      if (availableDay !== null) {
        daySelect.value = availableDay;
      }
    }

    this.windowsContainerTarget.appendChild(template);
    this.updateAddButtonVisibility();
  }

  removeWindow(event) {
    event.preventDefault();

    const transferWindowElement = event.target.closest(
      "[data-support-agent--transfer-windows-target='window']"
    );

    // If the window has an ID (persisted), mark it for destruction instead of removing it from the DOM
    const destroyField = transferWindowElement.querySelector(
      "[data-support-agent--transfer-windows-target='destroyField']"
    );
    const hasId = transferWindowElement.querySelector("input[name*='[id]']");

    if (hasId && hasId.value) {
      // This is a persisted window, mark for destruction
      destroyField.value = "1";
      transferWindowElement.style.display = "none";
    } else {
      // This is a new window, remove it from the DOM
      transferWindowElement.remove();
    }

    this.updateAddButtonVisibility();
  }

  updateAddButtonVisibility() {
    const visibleCount = this.windowTargets.filter(
      (window) => window.style.display !== "none"
    ).length;

    const addButton = this.addButtonContainerTarget.querySelector("button");
    if (addButton) {
      addButton.style.display = visibleCount >= 7 ? "none" : "inline-flex";
    }
  }

  hideMarkedForDestructionWindows() {
    // Hide windows that are marked for destruction on page load
    // This handles the case when form validation fails and page reloads
    this.windowTargets.forEach((window) => {
      const destroyField = window.querySelector(
        "[data-support-agent--transfer-windows-target='destroyField']"
      );
      if (destroyField && destroyField.value === "1") {
        window.style.display = "none";
      }
    });
  }

  getFirstAvailableDay() {
    const usedDays = new Set();

    // Get all visible windows and collect their days
    const visibleWindows = this.windowTargets.filter((window) => window.style.display !== "none");

    visibleWindows.forEach((window) => {
      const daySelect = window.querySelector("select[name*='[day_of_week]']");
      if (daySelect && daySelect.value) {
        usedDays.add(parseInt(daySelect.value));
      }
    });

    // Return the first available day (0-6)
    for (let day = 0; day < 7; day++) {
      if (!usedDays.has(day)) {
        return day;
      }
    }

    return null; // All days are used
  }
}
